// How many tasks are left, in words: "2 tasks to do", "All tasks done", "No tasks yet"; once a date has
// passed, "2 tasks not done". Key Date cards and Help me choose say it the same way.
export const taskWords = (tasks, past = false) => {
  const open = tasks.filter(t => !t.done).length;
  if (!tasks.length) return "No tasks yet";
  if (!open) return "All tasks done";
  return `${open} task${open === 1 ? "" : "s"} ${past ? "not done" : "to do"}`;
};
